import React from 'react';
import qs from 'qs';

const generateKey = pre => {
    return `${pre}_${new Date().getTime()}`;
};

class Pagination extends React.Component {
    constructor(props) {
        super(props);
        const pathname = window.location.pathname;
        this.baseURL = pathname;
        const search = window.location.search;
        this.parsedSearch = {};
        if (search) {
            this.parsedSearch = qs.parse(search, { ignoreQueryPrefix: true });
            delete this.parsedSearch.page;
            if (Object.keys(this.parsedSearch).length) {
                this.baseURL = `${this.baseURL}?${qs.stringify(this.parsedSearch)}`;
            }
        }
    }

    calculateLastPage = () => {
        const { activePageNumber, totalNumber, entriesPerPage } = this.props;

        let numberOfPages = totalNumber / entriesPerPage;
        numberOfPages = numberOfPages.toString();
        const number = numberOfPages.split('.');
        return number[1] ? parseInt(number[0]) + 1 : parseInt(number[0]);
    };

    handlePageClick = e => {
        const {
            saveStateKeyParent,
            activePageNumber,
            totalNumber
        } = this.props;
        const stateKeyName = 'currentPageNumber';

        // e.preventDefault();
        // e.stopPropagation();

        switch (e.currentTarget.text.toLowerCase()) {
            case '« first':
                saveStateKeyParent(stateKeyName, 1);
                break;
            case '‹ prev':
                saveStateKeyParent(stateKeyName, activePageNumber - 1);
                break;
            case 'next ›':
                saveStateKeyParent(stateKeyName, activePageNumber + 1);
                break;
            case 'last »':
                //total number / 8
                saveStateKeyParent(stateKeyName, this.calculateLastPage());
                break;
            default:
                saveStateKeyParent(
                    stateKeyName,
                    parseInt(e.currentTarget.text.toLowerCase())
                );
                break;
        }
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    renderLinks = () => {
        const {
            entriesPerPage,
            saveStateKeyParent,
            activePageNumber,
            totalNumber
        } = this.props;
        let links = [];
        let obs = 0;
        let lastPage = this.calculateLastPage();
        const prefix = Object.keys(this.parsedSearch).length ? '&' : '?';

        if (activePageNumber >= 2) {
            links.push(
                <li key={generateKey('first_li')}>
                    <a
                        key={generateKey('first_link')}
                        href={`${this.baseURL}${prefix}page=1`}
                        onClick={this.handlePageClick}
                    >
                        « First
                    </a>
                </li>
            );
            links.push(
                <li key={generateKey('prev_li')}>
                    <a
                        key={generateKey('prev_link')}
                        href={`${this.baseURL}${prefix}page=${activePageNumber - 1}`}
                        onClick={this.handlePageClick}
                    >
                        ‹ Prev
                    </a>
                </li>
            );
        }

        if (activePageNumber > 5) {
            links.push(
                <li key={generateKey('dots_before_li')}>
                    <a
                        key={generateKey('dots_before_a')}
                        className="disabled"
                        href="#"
                    >
                        ...
                    </a>
                </li>
            );
        }

        if (activePageNumber < 5) {
            for (let i = 1; i <= (lastPage < 5 ? lastPage : 5); i++) {
                links.push(
                    <li
                        key={generateKey(i + '_li')}
                        className={activePageNumber === i ? 'active' : ''}
                    >
                        <a
                            key={generateKey(i + '_link')}
                            href={`${this.baseURL}${prefix}page=${i}`}
                            onClick={this.handlePageClick}
                        >
                            {i}
                        </a>
                    </li>
                );
            }
        } else {
            for (let i = activePageNumber - 4; i <= activePageNumber; i++) {
                links.push(
                    <li
                        key={generateKey(i + '_li')}
                        className={activePageNumber === i ? 'active' : ''}
                    >
                        <a
                            key={generateKey(i + '_link')}
                            href={`${this.baseURL}${prefix}page=${i}`}
                            onClick={this.handlePageClick}
                        >
                            {i}
                        </a>
                    </li>
                );
            }
        }

        if (activePageNumber >= 5 && activePageNumber < lastPage) {
            // activePageNumber + 1 : the current page was already displayed in the first for() {} so we start at '+1'
            for (let i = activePageNumber + 1; i <= lastPage; i++) {
                if (obs > 3) {
                    break;
                }
                links.push(
                    <li
                        key={generateKey(i + '_li')}
                        className={activePageNumber === i ? 'active' : ''}
                    >
                        <a
                            key={generateKey(i + '_link')}
                            href={`${this.baseURL}${prefix}page=${i}`}
                            onClick={this.handlePageClick}
                        >
                            {i}
                        </a>
                    </li>
                );
                ++obs;
            }
        }

        if (activePageNumber < lastPage - 4) {
            links.push(
                <li key={generateKey('dots_after_li')}>
                    <a
                        key={generateKey('dots_after_link')}
                        className="disabled"
                        href="#"
                    >
                        ...
                    </a>
                </li>
            );
        }

        if (activePageNumber !== lastPage) {
            links.push(
                <li key={generateKey('next_li')}>
                    <a
                        key={generateKey('next_link')}
                        rel="next"
                        href={`${this.baseURL}${prefix}page=${activePageNumber * 1 + 1}`}
                        onClick={this.handlePageClick}
                    >
                        Next ›
                    </a>
                </li>
            );
            links.push(
                <li key={generateKey('last_li')}>
                    <a
                        key={generateKey('last_link')}
                        href={`${this.baseURL}${prefix}page=${lastPage}`}
                        onClick={this.handlePageClick}
                    >
                        Last »
                    </a>
                </li>
            );
        }

        return links;
    };

    render() {
        const { totalNumber, entriesPerPage, activePageNumber } = this.props;
        const minNrOfEntriesPerPage =
            activePageNumber === 1
                ? activePageNumber
                : entriesPerPage * (activePageNumber - 1);
        const maxNrOfEntriesPerPage =
            entriesPerPage * activePageNumber <= totalNumber
                ? entriesPerPage * activePageNumber
                : totalNumber;

        return (
            <div className="pagnation-controls text-center">
                <ul className="pagination">
                    {this.renderLinks().map(link => link)}
                </ul>
            </div>
        );
    }
}
export default Pagination;
